import { PageHeader } from '@fukuri-admins/ui/common';

type Props = {
  title: string;
  indexHref: string;
};

/**
 * 社内報詳細ヘッダーの Presentation コンポーネント
 * パンくずリスト付きページヘッダーを表示する
 */
export const InternalNewsDetailHeaderPresentation: React.FC<Props> = ({ title, indexHref }) => (
  <PageHeader
    variant='breadcrumb'
    breadcrumbItems={[{ label: '社内報', href: indexHref }, { label: title }]}
  />
);
